import { render, staticRenderFns } from "./BaCreateBidWantedModal.vue?vue&type=template&id=1daf01f0&scoped=true&"
import script from "./BaCreateBidWantedModal.vue?vue&type=script&lang=js&"
export * from "./BaCreateBidWantedModal.vue?vue&type=script&lang=js&"
import style0 from "./BaCreateBidWantedModal.vue?vue&type=style&index=0&id=1daf01f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daf01f0",
  null
  
)

export default component.exports